<template>


<header>

    <img style="width: 100%; height: 100%" alt="$ERFC" src="./assets/Banner_site3.png">
  
  <img class="image2" alt="$ERFC" src="./assets/logo.png">
  <img class="image4" alt="$ERFC" src="./assets/name.png">
  <a  href="https://www.cryptofishruneer.com/">
    <img class="image5" alt="$ERFC" src="./assets/back.png">
  </a>
</header>


  
  <MainPage msg=""/>
  <UserWallet msg="Connected Wallet"/>
  <SignUp msg="Autnticate"/>
</template>

<script>
import MainPage from './components/MainPage.vue'
import UserWallet from './components/UserWallet.vue'

export default {
  name: 'App',
  components: {
    MainPage,
    UserWallet,
}
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
  margin-top: 00px;
}

.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: relative;
  top: 0;
  left: 0;
  border: 0px red solid;
}
.image2 {
  position: absolute;
  top: 01px;
  left: 20px;
  border: 0px green solid;
  width: 12%;
  height: 23%;
}
.image3 {
  position: relative;
  top: 10px;
  left: 10px;
  border: 0px green solid;
  width: 100%;
  height: 21%;
}
.image4 {
  position: absolute;
  top: 28px;
  left: 160px;
  border: 0px green solid;
  
}
.image5 {
  position: absolute;
  top: 30px;
  left: 485px;
  border: 0px green solid;
  
}
</style>
